import gql from "graphql-tag"

const mutation = gql`
mutation GiftUserWalletCredit($userId: String!, $amount: Float!, $currency: String!, $reason: String!) {
  giftUserWalletCredit(userId: $userId, amount: $amount, currency: $currency, reason: $reason)
}
`

export const toString = mutation.loc.source.body

export default mutation
